<template>
  <div>
    <div class="container ht-100v tx-center">
      <div class="d-flex flex-column align-items-center justify-content-center">
        <div class="wd-70p wd-sm-250 wd-lg-300 mg-b-15">
          <img src="assets/svg/zoom.svg" class="img-fluid" alt="" />
        </div>
        <h1 class="tx-color-01 tx-24 tx-sm-32 tx-lg-36 mg-xl-b-5">
          {{ task.task }}
        </h1>
        <h5 class="tx-14 tx-normal text-uppercase mg-b-30">[Онлайн уулзалт]</h5>
        <p class="tx-color-03 mg-b-10">Үргэлжлэх хугацаа</p>
        <p class="tx-color-03">
          {{ task.dueStartDate | moment("YYYY.MM.DD HH:mm, dddd") }} -
          {{ task.dueDate | moment("YYYY.MM.DD HH:mm, dddd") }}
        </p>
        <vue-countdown
          @end="timerEnded"
          :time="getSeconds(task.dueStartDate)"
          v-slot="{ days, hours, minutes, seconds }"
          class="mg-b-30"
        >
          {{ days }}өдөр : {{ hours }}цаг : {{ minutes }}минут :
          {{ seconds }}секунд
        </vue-countdown>
        <div class="mg-b-40">
          <router-link
            :to="{
              name: 'lmsCourseView',
              params: { id: $route.params.id, bid: 0, iid: 0, bot: 0 }
            }"
            class="btn btn-white pd-x-30"
            >Сургалтын эхлэл</router-link
          >
          <a
            v-if="task.i1 == 1 && isStarted"
            :href="task.taskEn"
            target="_blank"
            class="btn btn-primary text-white mg-l-10"
            >Цахм хуралд оролцох</a
          >
        </div>
      </div>
    </div>
    <!-- <div class="pd-20 pd-lg-25 pd-xl-30">
      <div class="d-flex">
        <div class="mg-l-10 pd-t-20">
          <p class="mg-b-2 text-muted">Онлайн уулзалт: {{task.task}}</p>
          <p
            class="mg-b-2 text-muted"
          >Эхлэх: {{task.dueStartDate | moment('YYYY.MM.DD HH:mm')}}</p>
          <p
            class="mg-b-0 text-muted"
          >Дуусах: {{task.dueDate | moment('YYYY.MM.DD HH:mm')}}</p>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import VueCountdown from "@chenfengyuan/vue-countdown";
import { hasOneOf } from "@/libs/tools";
export default {
  components: {
    VueCountdown
  },
  props: {
    task: {
      type: Object,
      default: () => {}
    },
    course: {
      type: Object,
      default: () => {}
    },
    isStarted: {
      type: Boolean,
      default: () => false
    }
  },
  data: function() {
    return {
      isEnded: false
    };
  },
  mounted() {
    if (
      (this.task.i1 == 1 ||
        (this.task.i1 == 2 &&
          this.hasPermission(["learningstudent"]) &&
          !this.hasPermission(["learningteacher", "learningadmin"]))) &&
      this.isStarted
    ) {
      //this.$emit('on-detail', this.task.id);

      window.open(this.task.taskEn, "_blank");
    }
  },
  methods: {
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    getSeconds(d) {
      let _range =
        new Date(d).getTime() - new Date(this.course.date.now).getTime();
      if (_range > 0) {
        return _range;
      }
    },
    timerEnded() {
      //this.isEnded= true;
      if (
        this.task.i1 == 1 ||
        (this.task.i1 == 2 &&
          this.hasPermission(["learningstudent"]) &&
          !this.hasPermission(["learningteacher", "learningadmin"]))
      )
        window.open(this.task.taskEn, "_blank");
      else this.$emit("on-detail", this.task.id);
      //console.log('timerEnded');
    }
  }
};
</script>
